<!--
/*******************************************************************************
*@ 컴포넌트명   : FvrtAcnSetPopup.vue
*@ 컴포넌트설명 : 자주 보는 계좌 등록/삭제
*@ 사용전문     : RBF0404F40 - 전계좌조회요약
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <popup
      :opened.sync="openData"
      :use-header="true"
      :use-footer="true"
      :useTopBorder="false"
      :btnAreaPadding="true"
      title="Favorite Account"
      class="bg-gray"
      @cancel="$emit('change')"
    >
      <template #content>
        <div v-if="siteCode == $config.SITECODE_OGHCM" class="info info-type4">{{ /*★을 누르면 이체 거래의 메인 출금계좌로 설정됩니다.*/ $t("MMAIN-03-02-04-05") }}</div>
        <!-- 내계좌 -->
        <card-drag ref="card" :horizontal="false" :list="fvrtList">
          <template v-slot:card="item">
            <div class="inner">
              <div class="header">
                <i class="icon icon-drag-drop" />
                <div v-if="siteCode == $config.SITECODE_OGHCM" class="title" @click="fvrtAcnChk(item.index)">
                  <div class="name text-ellipsis">
                    <i :class="[fvrtIdx == item.index ? 'icon icon-withdrawal-main' : 'icon icon-withdrawal-main-off']" />
                    {{ item.card.acnoAls ? item.card.acnoAls : item.card.prdctName }}
                  </div>
                  <div class="badge" :class="getColrCdCtnt(item.card)">
                    {{
                      item.card.acnoKnd == "1"
                        ? item.card.acnoKnd2 == "3"
                          ? /*입출금*/ $t("MMAIN-03-02-01-02")
                          : /*예/적금*/ $t("MMAIN-03-02-01-03")
                        : /*대출*/ $t("MMAIN-03-02-01-04")
                    }}
                  </div>
                </div>
                <div v-else class="title">
                  {{ item.card.acnoAls ? item.card.acnoAls : item.card.prdctName }}
                  <div class="badge" :class="getColrCdCtnt(item.card)">
                    {{
                      item.card.acnoKnd == "1"
                        ? item.card.acnoKnd2 == "3"
                          ? /*입출금*/ $t("MMAIN-03-02-01-02")
                          : /*예/적금*/ $t("MMAIN-03-02-01-03")
                        : /*대출*/ $t("MMAIN-03-02-01-04")
                    }}
                  </div>
                </div>
                <div class="desc">
                  <div class="item account">
                    {{
                      item.card.acnoKnd == "1"
                        ? `${item.card.acno} - ${item.card.prdctName}`
                        : `${item.card.acno} - ${/*대출금리*/ $t("MMAIN-03-03-02-16")} ${item.card.lnIrt ? item.card.lnIrt : "0"}%`
                    }}
                  </div>
                </div>
              </div>
              <div class="content">
                <div class="account-info -type3">
                  <!-- 금액표시여부 -->
                  <div class="item amount" v-if="item.card.amtRepsntYn == '1'">
                    <span class="exchange-unit">{{ item.card.cncycd }}</span>
                    <span class="total" v-html="$num(item.card.bal, null, true)"></span>
                  </div>
                  <!-- 이자납입금액표시여부 -->
                  <div class="item amount" v-if="item.card.intPamtRepsntYn == '1'">
                    <span class="date" v-if="item.card.acnStus == '2'">{{ `${$getGlobalDateFmt(item.card.nxtrmPaymtYmd)} (${$t("2_계좌상태구분코드")})` }}</span>
                    <span class="date" v-else-if="item.card.rmainNxtrmPaymtNoday > 0 || item.card.rmainNxtrmPaymtNoday < 0"
                      >{{ $getGlobalDateFmt(item.card.nxtrmPaymtYmd) }}
                      {{
                        item.card.rmainNxtrmPaymtNoday > 0 ? `(D-${item.card.rmainNxtrmPaymtNoday.toString()})` : `(D+${(item.card.rmainNxtrmPaymtNoday * -1).toString()})`
                      }}</span
                    >
                    <span class="date" v-else>{{ `${$getGlobalDateFmt(item.card.nxtrmPaymtYmd)}` }}</span>
                    <!-- 당좌대출 차기이자납부금액 미표시 -->
                    <span v-if="item.card.ovsesLnFmatDstcd != '08'" class="exchange-unit">{{ item.card.cncycd }}</span>
                    <span v-if="item.card.ovsesLnFmatDstcd != '08'" class="total" v-html="$num(item.card.nxtrmIntPaymtAmt, null, true)"></span>
                  </div>
                  <!-- 당일 입/출금 합계 표시 -->
                  <div class="item amount" v-if="item.card.ttddRcdrwSumRepsntYn == '1'">
                    <span class="in">(in)</span>
                    <span class="exchange-unit">{{ item.card.cncycd }}</span>
                    <span class="total" v-html="$num(item.card.ttddMrvamtSum, null, true)"></span>
                  </div>
                  <div class="item amount" v-if="item.card.ttddRcdrwSumRepsntYn == '1'">
                    <span class="out">(out)</span>
                    <span class="exchange-unit">{{ item.card.cncycd }}</span>
                    <span class="total" v-html="$num(item.card.ttddDrwotamtSum, null, true)"></span>
                  </div>
                  <div
                    class="item sub"
                    v-if="
                      item.card.drwotAblamtRepsntYn == '1' ||
                      item.card.newYmdRepsntYn == '1' ||
                      item.card.dpostIrtRepsntYn == '1' ||
                      item.card.ctrcTrmRepsntYn == '1' ||
                      (item.card.updatYmdRepsntYn == '1' && item.card.expirExtenYn == '1') ||
                      item.card.lnAmtRepsntYn == '1' ||
                      item.card.lnBalRepsntYn == '1' ||
                      item.card.expirYmdRepsntYn == '1' ||
                      item.card.acnStusRepsntYn == '1'
                    "
                  >
                    <div class="cont" v-if="item.card.drwotAblamtRepsntYn == '1'">
                      <span class="tit">{{ /*출금 가능 금액*/ $t("MPAY-03-01-06-02") }}</span>
                      <span class="dec">{{ $num(item.card.drwotAbilAmt) }}</span>
                    </div>
                    <div class="cont" v-if="item.card.newYmdRepsntYn == '1'">
                      <span class="tit">{{ /*신규일*/ $t("MMAIN-03-04-10-05") }}</span>
                      <span class="dec">{{ $getGlobalDateFmt(item.card.newYmd) }}</span>
                    </div>
                    <div class="cont" v-if="item.card.dpostIrtRepsntYn == '1'">
                      <span class="tit">{{ /*예금 이율*/ $t("MMAIN-03-03-02-02") }}</span>
                      <span class="dec">{{ `${item.card.dpostIrt}%` }}</span>
                    </div>
                    <div class="cont" v-if="item.card.ctrcTrmRepsntYn == '1'">
                      <span class="tit">{{ /*계약기간*/ $t("MDEP-01-01-02-05") }}</span>
                      <span class="dec">{{ `${$getGlobalDateFmt(item.card.expirYmd)} ~ ${$getGlobalDateFmt(item.card.newYmd)}` }}</span>
                    </div>
                    <div class="cont" v-if="item.card.updatYmdRepsntYn == '1' && item.card.expirExtenYn == '1'">
                      <span class="tit">{{ /*갱신일*/ $t("MINQ-01-01-08-20") }}</span>
                      <span class="dec">{{ $getGlobalDateFmt(item.card.expirExtenYmd) }}</span>
                    </div>
                    <div class="cont" v-if="item.card.lnAmtRepsntYn == '1'">
                      <span class="tit">{{ /*대출금액*/ $t("MINQ-01-01-10-07") }}</span>
                      <span class="dec">{{ $num(item.card.lnAmt) }}</span>
                    </div>
                    <div class="cont" v-if="item.card.lnBalRepsntYn == '1'">
                      <span class="tit">{{ /*대출잔액*/ $t("MINQ-01-01-10-08") }}</span>
                      <span class="dec">{{ $num(item.card.lnBal) }}</span>
                    </div>
                    <div class="cont" v-if="item.card.expirYmdRepsntYn == '1'">
                      <span class="tit">{{ /*만기일*/ $t("MMAIN-03-03-02-03") }}</span>
                      <span class="dec">{{ $getGlobalDateFmt(item.card.lnExpirYmd) }}</span>
                    </div>
                    <div class="cont" v-if="item.card.acnStusRepsntYn == '1'">
                      <span class="tit">{{ /*계좌 상태*/ $t("MMAIN-03-03-03-04") }}</span>
                      <span class="dec">{{ $t(`${item.card.acnStus}_계좌상태구분코드`) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bottom">
                <div class="btn-area--bottom">
                  <button class="btn sm outline" @click="modFrcvAcn(item.index)">
                    <i class="icon icon-edit" />
                    {{ /*수정*/ $t("MPRS-02-02-01-08") }}
                  </button>
                  <button class="btn sm outline" @click="delFrcvAcn(item.index)">
                    <i class="icon icon-delete" />
                    {{ /*삭제*/ $t("MPRS-02-02-01-09") }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </card-drag>
        <!-- 계좌등록 -->
        <div class="account-blank" v-for="data in fvrtEmptyList" :key="data" @click="addFvrtAcn()">
          <span>Add Account</span>
        </div>
      </template>
      <template #footer>
        <button class="btn md normal" @click="saveFrcvAcn">{{ /*저장하기*/ $t("MMAIN-03-04-03-01") }}</button>
      </template>
    </popup>

    <!-- action sheet 들어 가는 곳 -->
    <action-sheet :opened.sync="openedFrvtAdd" :btn-area-padding="true" :no-header-padding="true" class="action-sheet action-sheet--list-type tabs-type">
      <template #content>
        <tab css-type="type3" :title-list="['MMAIN-03-04-04-01', 'MMAIN-03-04-04-02', 'MMAIN-03-04-04-03']">
          <template #0>
            <strong class="total-count no-border">{{ `${/*합계*/ $t("MPRS-02-02-01-07")} : ${wdrwList.length}` }}</strong>
            <ul>
              <li v-for="data in wdrwList" :key="data.acno + '@' + data.acnoKnd2" @click="onAddFvrtAcn(data)">
                {{ data.acnoAls ? data.acnoAls : data.prdctName }}
                <span class="desc">{{ `${data.acno} - ${data.prdctName}` }}</span>
              </li>
            </ul>
          </template>
          <template #1>
            <strong class="total-count no-border">{{ `${/*합계*/ $t("MPRS-02-02-01-07")} : ${dpostList.length}` }}</strong>
            <ul>
              <li v-for="data in dpostList" :key="data.acno + '@' + data.acnoKnd2" @click="onAddFvrtAcn(data)">
                {{ data.acnoAls ? data.acnoAls : data.prdctName }}
                <span class="desc">{{ `${data.acno} - ${data.prdctName}` }}</span>
              </li>
            </ul>
          </template>
          <template #2>
            <strong class="total-count no-border">{{ `${/*합계*/ $t("MPRS-02-02-01-07")} : ${lnList.length}` }}</strong>
            <ul>
              <li v-for="data in lnList" :key="data.acno + '@' + data.acnoKnd2" @click="onAddFvrtAcn(data)">
                {{ data.acnoAls ? data.acnoAls : data.prdctName }}
                <span class="desc">{{ `${data.acno} - ${data.prdctName}` }}</span>
              </li>
            </ul>
          </template>
        </tab>
      </template>
      <template #footer>
        <button class="btn bottom positive">{{ /*확인*/ $t("MCOM-0000003") }}</button>
      </template>
    </action-sheet>
    <modal-pop :opened.sync="openedValidation" class="modal" confirm="MCOM-0000003">
      <template #content>{{ $t(validationErrorMsg) }}</template>
    </modal-pop>
    <fvrt-acn-mod-popup :opened.sync="openedFrvtMod" @change="changeFrvtMod" />
  </article>
</template>

<script>
import CardDrag from "@/components/page/common/CardDrag";
import FvrtAcnModPopup from "@/components/page/main/FvrtAcnModPopup";
import { mapFields } from "vuex-map-fields";
import { mapActions, mapGetters } from "vuex";
import Common from "@/components/basic/Common";
import NapasQR from "@/qr/NapasQR.js";
import CRCModule from "@/qr/CrcCitt.js";

export default {
  extends: Common,
  props: ["opened"],
  components: {
    CardDrag,
    FvrtAcnModPopup,
  },
  mounted() {},
  data() {
    return {
      fvrtList: [], //내계좌설정(계좌목록)
      fvrtEmptyList: [], //내계좌설정(빈계좌목록)
      currIdx: -1,

      initWholAcn: true,

      validationErrorMsg: "",

      showAcnDtl: false, //계좌상세보기
      openedFrvtAdd: false, //내계좌추가
      openedFrvtMod: false, //내계좌수정
      openedValidation: false, //Validation
      fvrtIdx: null,
      fvrtAcn: null,
      qrStatus: "", // 금액 없을 때
      bankInfo: "",
    };
  },
  computed: {
    ...mapFields("common/main", ["accountList", "RBF0404L40"]),
    ...mapGetters("common/main", ["getFvrtAcnTemplate"]),
    ...mapFields(["operGroupCd", "siteCode"]),
    ...mapGetters("native", ["getNativeAll"]),
    openData: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
    wdrwList() {
      let list = [];

      if (!_.isNil(this.accountList)) {
        list = this.accountList.dataGrid2.filter(item => {
          return (
            item.acnoKnd2 == "3" &&
            this.fvrtList.findIndex(v => {
              return v.acno == item.acno && v.acnoKnd == item.acnoKnd;
            }) < 0
          );
        });
      }

      return list;
    },
    dpostList() {
      let list = [];

      if (!_.isNil(this.accountList)) {
        list = this.accountList.dataGrid2.filter(item => {
          return (
            item.acnoKnd2 == "4" &&
            this.fvrtList.findIndex(v => {
              return v.acno == item.acno && v.acnoKnd == item.acnoKnd;
            }) < 0
          );
        });
      }

      return list;
    },
    lnList() {
      let list = [];

      if (!_.isNil(this.accountList)) {
        list = this.accountList.dataGrid2.filter(item => {
          return (
            item.acnoKnd2 == "2" &&
            this.fvrtList.findIndex(v => {
              return v.acno == item.acno && v.acnoKnd == item.acnoKnd;
            }) < 0
          );
        });
      }

      return list;
    },
  },
  methods: {
    ...mapActions("common/main", ["ACT_setFvrtAcnTmp"]),
    init() {
      if (this.initWholAcn) {
        return new Promise(resolve => {
          this.$post(
            "/account/inqury/WholAcnInq",
            {},
            response => {
              if (this.siteCode != this.$config.SITECODE_OGHCM) {
                this.initWholAcn = false;
              }
              this.$set(this, "accountList", response.outItem);
            },
            null,
            () => {
              let fvrtCnt = this.RBF0404L40.totalLineCnt2;
              let rnum = 0;

              this.fvrtList = [];
              this.fvrtIdx = null;

              if (fvrtCnt > 0) {
                this.RBF0404L40.dataGrid2.forEach(item => {
                  this.fvrtList.push({ ...item });
                });

                this.fvrtList.forEach((item, idx) => {
                  item.rnum = rnum++;
                  if (this.siteCode == this.$config.SITECODE_OGHCM && item.rpsntDrwotAcnYn == "1") {
                    // 베트남 메인출금계좌 불러오기
                    this.fvrtIdx = idx;
                  }
                });
              }
              this.resetEmptyList();
              resolve(true);
            },
          );
        });
      }
    },
    RBF0601F60Call() {
      this.loading = true;

      let params = {
        inDataGrid: this.fvrtList,
      };

      this.$post(
        "/account/fvrt/FvrtAcnSave",
        params,
        this.RBF0601F60Suc,
        () => {
          this.loading = false;
          if (this.siteCode == this.$config.SITECODE_OGHCM) {
            // 베트남 메인출금계좌 관련 값 리셋
            this.fvrtIdx = null;
            this.RBF0404L40.dataGrid2.forEach((item, index) => {
              if (item.rpsntDrwotAcnYn == "1") {
                // 베트남 메인출금계좌 불러오기
                this.fvrtIdx = index;
              }
            });
          }
        },
        null,
        null,
        false,
      );
    },
    RBF0601F60Suc() {
      this.loading = false;
      this.$set(this.RBF0404L40, "totalLineCnt2", this.fvrtList.length);
      this.$set(this.RBF0404L40, "dataGrid2", this.fvrtList);
      this.$emit("change");
      this.openData = false;
      if (this.siteCode == this.$config.SITECODE_OGHCM) {
        // 베트남 QR 위젯 생성
        if (
          // 앱 최신버전(AOS-2.4.4, iOS-2.1.9)일 때만 QR 생성 브릿지 코드 호출
          (this.getNativeAll.smphMchtlDstcd == this.$config.OS_ANDROID && parseInt(this.getNativeAll.appVersionName.replace(/\./g, "")) >= 244) ||
          (this.getNativeAll.smphMchtlDstcd == this.$config.OS_IOS && parseInt(this.getNativeAll.appVersionName.replace(/\./g, "")) >= 219)
        ) {
          if (this.fvrtIdx != null) {
            this.fvrtAcn = this.fvrtList[this.fvrtIdx];

            // QR String 생성
            const napasInstance = new NapasQR();
            this.qrStatus = "11"; // 금액 없을 때
            if (this.operGroupCd == "VN1") {
              this.bankInfo = "970463";
            } else if (this.operGroupCd == "VN2") {
              this.bankInfo = "970462";
            }

            // 첫 번째 파라미터 "" : 수취인 없이 보내기
            let qrCrc = napasInstance.makeCRCWithQRString("", this.fvrtAcn.acno, "", this.fvrtAcn.cncycd, "VN", this.qrStatus, this.bankInfo);
            let newCrc = CRCModule.getCRC(qrCrc);
            let qrStr = napasInstance.convertKVtoQRString2("", this.fvrtAcn.acno, "", this.fvrtAcn.cncycd, "VN", newCrc, this.qrStatus, this.bankInfo);

            this.$bridge.setWidgetInfo("0", qrStr); // 브릿지 통신을 통해 네이티브로 값 전달
          } else {
            this.$bridge.setWidgetInfo("0", ""); // 브릿지 통신을 통해 네이티브로 공백값 전달
          }
        }
      }
    },
    modFrcvAcn(num) {
      this.ACT_setFvrtAcnTmp(this.fvrtList[num]);
      this.currIdx = num;
      this.openedFrvtMod = true;
    },
    delFrcvAcn(num) {
      this.fvrtList.splice(num, 1);
      if (this.siteCode == this.$config.SITECODE_OGHCM) {
        // 베트남 메인출금계좌 관련 값 리셋
        if (num == this.fvrtIdx) {
          this.fvrtIdx = null;
        } else {
          this.fvrtList.forEach((item, idx) => {
            if (item.rpsntDrwotAcnYn == "1") {
              // 베트남 메인출금계좌 불러오기
              this.fvrtIdx = idx;
            }
          });
        }
      }
      this.resetEmptyList();
    },
    saveFrcvAcn() {
      if (this.RBF0404L40.dataGrid2 != this.fvrtList && (this.RBF0404L40.totalLineCnt2 > 0 || this.fvrtList.length > 0)) {
        let serno = 1;

        this.fvrtList.forEach((item, idx) => {
          item.lnpSeqSerno = serno++;
          if (this.siteCode == this.$config.SITECODE_OGHCM && idx == this.fvrtIdx) {
            // 베트남 메인출금계좌 설정
            item.rpsntDrwotAcnYn = "1";
          } else {
            item.rpsntDrwotAcnYn = "0";
          }
        });

        this.RBF0601F60Call();
      } else {
        this.$emit("change");
        this.openData = false;
      }
    },
    addFvrtAcn() {
      this.openedFrvtAdd = true;
    },
    onAddFvrtAcn(data) {
      if (data.ovsesLnFmatDstcd == "08") {
        this.validationErrorMsg = "MPAY-02-01-28-15"; //해당상품은 Favorite Account로 등록하실 수 없습니다.
        this.openedValidation = true;
        return;
      }

      if (
        this.fvrtList.findIndex(item => {
          return item.acno == data.acno && item.acnoKnd == data.acnoKnd;
        }) > -1
      ) {
        this.validationErrorMsg = "MPAY-02-01-28-14"; //이미 등록된 입금계좌번호입니다. 계좌번호를 확인해주시기 바랍니다.
        this.openedValidation = true;
        return;
      }

      this.fvrtList.push({ ...this.getFvrtAcnTemplate, ...data });

      //set init value
      this.fvrtList[this.fvrtList.length - 1].rnum = this.fvrtList.length - 1;

      if (data.acnoKnd2 == "3") {
        this.fvrtList[this.fvrtList.length - 1].amtRepsntYn = "1"; //금액표시여부
      } else if (data.acnoKnd2 == "4") {
        this.fvrtList[this.fvrtList.length - 1].amtRepsntYn = "1"; //금액표시여부
      } else if (data.acnoKnd2 == "2") {
        this.fvrtList[this.fvrtList.length - 1].intPamtRepsntYn = "1"; //이자납입금액표시여부
      }

      if (this.siteCode == this.$config.SITECODE_OGHCM && data.rpsntDrwotAcnYn == "1") {
        // 베트남 메인출금계좌 불러오기
        this.fvrtIdx = this.fvrtList.length - 1;
      }

      this.resetEmptyList();
      this.openedFrvtAdd = false;
    },
    changeFrvtMod(data) {
      this.fvrtList[this.currIdx] = data;
      this.$refs.card.$forceUpdate();
    },
    resetEmptyList() {
      if (this.fvrtList.length < this.$config.MAX_FVRT_ACN_CNT) {
        let fvrtCnt = this.fvrtList.length;

        this.fvrtEmptyList = new Array(this.$config.MAX_FVRT_ACN_CNT - fvrtCnt).fill(fvrtCnt).map((n, i) => {
          return n + i;
        });
      } else if (this.fvrtList.length == this.$config.MAX_FVRT_ACN_CNT) {
        this.fvrtEmptyList = [];
      } else {
        this.fvrtEmptyList = [0, 1, 2];
      }
    },
    getColrCdCtnt(data) {
      var regExp = /[type][0-9]/gi;

      if (regExp.test(data.colrCdCtnt)) {
        return "-" + data.colrCdCtnt;
      } else {
        return data.acnoKnd == "1" ? (data.acnoKnd2 == "3" ? "-type1" : "-type2") : "-type3";
      }
    },
    fvrtAcnChk(index) {
      if (this.fvrtIdx == index) {
        this.fvrtIdx = null;
      } else {
        this.fvrtIdx = index;
      }
    },
  },
};
</script>
